// PersonalInformation/validationRules.js
export const personalInfoRules = {
  fullName: { required: true, label: "Full Name" },
  mobile: {
    required: true,
    custom: (value) => {
      const digitsOnly = value.replace(/\D/g, "");
      return digitsOnly.length >= 10; // you can use === 10 if you want exactly 10 digits
    },
    message: {
      custom: "Please enter a valid phone number",
    },
    label: "Mobile",
  },
  email: {
    required: true,
    pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    message: {
      pattern: "Invalid email format",
    },
    label: "Email",
  },
  birthDate: { required: true, label: "Birth Date" },
  gender: { required: true, label: "Gender" },
  addressLine1: { required: true, label: "Address" },
  // addressLine2: { required: true, label: "Address" },
  // landmark: { required: true, label: "Landmark" },
  city: { required: true, label: "City" },
  state: { required: true, label: "State" },
  zip: {
    required: true,
    pattern: /^[0-9]{5}$/, 
    message: {
      pattern: "Zip code must be exactly 5 digits",
    },
    label: "Zip",
  },
};

//other details
export const otherDetailsRules = {
  vechicalType: {
    required: true,
    label: "vechical Type",
  },
  licencePlateNumber: {
    required: true,
    label: "Licence Plate Number",
  },
};

//Store Details
export const storeDetailsRules = {
  storeName: {
    required: true,
    label: "Store Name",
  },

    storeContactNumber: {
    required: true,
    custom: (value) => {
      const digitsOnly = value.replace(/\D/g, "");
      return digitsOnly.length >= 10; 
    },
    message: {
      custom: "Please enter a valid phone number",
    },
    label: "Mobile",
  },
  storeLicenseNumber: {
    required: true,
    label: "Store License Number",
  },
  addressLine1: { required: true, label: "Address" },
  // addressLine2: { required: true, label: "Address" },
  // landmark: { required: true, label: "Landmark" },
  city: { required: true, label: "City" },
  state: { required: true, label: "State" },
  zip: {
    required: true,
    pattern: /^[0-9]{5}$/, 
    message: {
      pattern: "Zip code must be exactly 5 digits",
    },
    label: "Zip",
  },
  
};

//other details
export const bankDetails = {
  accountNumber: {
    required: true,
    label: "Account Number",
  },
  accountName: {
    required: true,
    label: "Account Name",
  },
  bankName: {
    required: true,
    label: "Bank Name",
  },
  routingNumber: {
    required: true,
    label: "Routing Number",
  },
};

//other details
export const serviceOffered = {
  serviceType: { required: true, label: "Service Type" },
  category: { required: true, label: "Category" },
  unit: { required: true, label: "Unit" },
  tailoringType: { required: false, label: "Tailoring Type" },
  clothType: { required: false, label: "Cloth" },
  lbs: { required: false, label: "lbs" },
  price: {
    required: true,
    pattern: /^[0-9]+(\.[0-9]{1,2})?$/,
    message: { pattern: "Enter a valid number" },
    label: "Price",
  },
  description: { required: false, label: "Description" },
};

export const campaignRule = (formData) => {
  const requiredFields = {
    name: { required: true, label: "Campaign Name" },
    code: { required: true, label: "Promo Code" },
    promotionType: { required: true, label: "Promotion Type" },
    startDate: { required: true, label: "Start Date" },
    endDate: { required: true, label: "End Date" },
    service_type: { required: true, label: "Service Type" },
    // customerTag: { required: true, label: "Customer Tag" },
    // region: { required: true, label: "Region" },
    // minimum_order_count: { required: true, label: "Minimum Order Count" },
  };

  const promotionTypeFields = {
    flat_percent: ['xValue'],
    flat_dollar: ['xValue'],
    buy_x_get_rs_y_off: ['xValue', 'yValue'],
    buy_x_get_y_percent_upto_z: ['xValue', 'yValue'],
    flat_percent_if_greater_than_x: ['xValue'],
  };

  const fieldsToRequire = promotionTypeFields[formData.promotionType] || [];

  fieldsToRequire.forEach((field) => {
    requiredFields[field] = {
      required: true,
      label: field === 'xValue' ? 'X Value' : 'Y Value',
      pattern: /^[0-9]+(\.[0-9]{1,2})?$/, // number pattern, adjust if needed
      message: {
        pattern: "Enter a valid amount",
      },
    };
  });

  return requiredFields;
};


export const pricingTierRule = {
minQty: {
  required: true,
  label: "Minimum Quantity",
  // pattern: /^\d{1,3}$/,
  // message: { pattern: "Must be up to 3 digits only" },
},
maxQty: {
  required: true,
  label: "Maximum Quantity",
  // pattern: /^\d{1,3}$/,
  // message: { pattern: "Must be up to 3 digits only" },
},
discount: {
  required: true,
  pattern: /^[0-9]+(\.[0-9]{1,2})?$/,
  custom: (value) => parseFloat(value) <= 100,
  customMessage: "Value must be less than equal to 100",
  message: { pattern: "Enter a valid discount (e.g., 10 or 10.50)" },
  label: "Discount Percentage",
},
 serviceType: {
    required: true,
    label: "Service Type",
  },
  startDate: {
    required: true,
    label: "Start Date",
  },
  endDate: {
    required: true,
    label: "End Date",
  },
  // points: {
  //   required: true,
  //   label: "Benefits / Points",
  // },
  status: {
    required: true,
    label: "Status",
  },
};


export const inventoryValidationRules = {
  name: {
    required: true,
    label: "Item Name",
  },
  sku: {
    required: true,
    label: "SKU",
  },
  description: {
    required: false,
    label: "Description",
  },
  quantity: {
    required: true,
    pattern: /^[0-9]+$/, // only integers
    message: {
      pattern: "Quantity must be a valid number",
    },
    label: "Quantity",
  },
  price: {
    required: true,
    pattern: /^[0-9]+(\.[0-9]{1,2})?$/, // allows decimal with max 2 digits
    message: {
      pattern: "Price must be a valid number (up to 2 decimal places)",
    },
    label: "Price Per Quantity",
  },
  category: {
    required: true,
    label: "Category",
  },
  applicableCategory: {
    required: true,
    label: "Applicable Category",
  },

};


export const addressRules = {
  addressLine1: { required: true, label: "Address" },
  // addressLine2: { required: true, label: "Address" },
  // landmark: { required: true, label: "Landmark" },
  city: { required: true, label: "City" },
  state: { required: true, label: "State" },
    zip: {
    required: true,
    pattern: /^[0-9]{5}$/, 
    message: {
      pattern: "Zip code must be exactly 5 digits",
    },
    label: "Zip",
  },
};

export const profileRules = {
  name: { required: true, label: "Full Name" },
  mobile: {
    required: true,
    custom: (value) => {
      const digitsOnly = value.replace(/\D/g, "");
      return digitsOnly.length >= 10; // you can use === 10 if you want exactly 10 digits
    },
    message: {
      custom: "Please enter a valid phone number",
    },
    label: "Mobile",
  },
  email: {
    required: true,
    pattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
    message: {
      pattern: "Invalid email format",
    },
    label: "Email",
  },
  gender: { required: true, label: "Gender" },
  dob: { required: true, label: "Birth Date" },
};

export const missMatchRules = {
  imageUrl: {
    required: true,
    label: "Image",
  },
  expectedValue: {
    required: true,
    label: "Expected quantity/weight",
  },
    actualValue: {
    required: true,
    label: "Actual quantity/weight",
  },
  additionalCharge: {
    required: true,
    label: "Additional Charge",
  },
  message: {
    required: true,
    label: "Message",
  },

};